var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 268,
    viewBox: "0 0 629 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    clipPath: "url(#clip0_3855_5944)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.035 164.222V267.623H215.092V205.828H210.397V175.127L224.035 164.222Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.092 205.828H202.328V267.623H215.092V205.828Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.455 218.834H228.451V267.623H243.455V218.834Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.739 267.623H333.124V128.257L314.739 142.962V267.623Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.74 24.5762H333.492V267.623H357.74V24.5762Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.179 6.375V24.5765",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 32.5596H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 32.5596H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 39.1982H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 39.1982H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 45.8438H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 45.8438H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 52.4824H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 52.4824H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 59.1289H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 59.1289H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 65.7676H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 65.7676H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 72.4141H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 72.4141H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 79.0518H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 79.0518H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 85.6982H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 85.6982H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 92.3379H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 92.3379H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 98.9834H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 98.9834H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 105.622H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 105.622H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 112.269H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 112.269H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 118.907H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 118.907H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 125.553H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 125.553H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 132.191H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 132.191H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 138.838H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 138.838H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 145.477H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 145.477H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 152.122H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 152.122H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 158.762H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 158.762H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 165.407H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 165.407H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 172.046H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 172.046H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 178.692H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 178.692H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 185.331H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 185.331H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 191.978H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 191.978H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 198.616H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 198.616H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 205.261H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 205.261H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 211.9H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 211.9H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 218.546H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 218.546H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 225.185H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 225.185H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 231.831H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 231.831H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 238.47H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 238.47H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 245.116H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 245.116H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 251.755H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 251.755H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M335.836 258.4H340.289",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47 258.4H353.28",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M462.464 142.953V267.622H446.989V230.585H441.559V173.828H436.783V128.256L462.464 142.953Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M446.989 230.585V267.623H385.788V230.585H391.218V173.828H396.001V33.624H436.783V173.828H441.559V230.585H446.989Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M415.51 0V33.6237",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M396.001 173.835H417.861",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M441.559 230.593H406.928",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M405.891 42.2715V165.604",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M416.384 42.2715V165.604",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M426.878 42.2715V165.604",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M284.892 98.4326V136.112",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M290.366 115.569V136.112",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M300.323 136.104V267.624H259.174V267.593H265.199V265.615H264.273V257.548H265.743C265.743 254.535 263.641 252.02 260.864 251.476C260.871 251.439 260.871 251.401 260.871 251.363C260.871 250.713 260.357 250.185 259.725 250.185C259.526 250.185 259.335 250.238 259.174 250.336V187.967H269.461V136.104H300.323Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M295.546 141.686H281.585V148.045H295.546V141.686Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M295.546 151.134H281.585V157.493H295.546V151.134Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M295.546 160.099H281.585V166.458H295.546V160.099Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M277.199 187.937H269.461",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M267.146 191.939V240.759",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M279.778 191.939V249.656",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M292.401 191.939V238.84",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M255.176 257.578V265.644H264.273V257.578H255.176ZM259.725 261.77C259.526 261.77 259.335 261.717 259.174 261.619C258.821 261.422 258.579 261.037 258.579 260.592C258.579 260.146 258.821 259.761 259.174 259.564C259.335 259.466 259.526 259.413 259.725 259.413C260.357 259.413 260.871 259.942 260.871 260.592C260.871 261.241 260.357 261.77 259.725 261.77Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M265.199 265.645H254.251V267.623H265.199V265.645Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M260.871 260.592C260.871 261.249 260.356 261.77 259.724 261.77C259.526 261.77 259.335 261.718 259.173 261.619C258.82 261.423 258.578 261.038 258.578 260.592C258.578 260.147 258.82 259.761 259.173 259.565C259.335 259.467 259.526 259.414 259.724 259.414C260.356 259.414 260.871 259.943 260.871 260.592Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M260.871 251.393C260.871 251.431 260.871 251.469 260.863 251.506C260.496 251.431 260.114 251.393 259.724 251.393C259.541 251.393 259.357 251.401 259.173 251.423C258.975 251.438 258.776 251.469 258.585 251.506C258.578 251.469 258.578 251.431 258.578 251.393C258.578 250.947 258.82 250.562 259.173 250.366C259.335 250.268 259.526 250.215 259.724 250.215C260.356 250.215 260.871 250.744 260.871 251.393Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M265.742 257.579H253.706C253.706 254.566 255.808 252.051 258.585 251.507C258.777 251.469 258.975 251.439 259.173 251.424C259.357 251.401 259.541 251.394 259.724 251.394C260.114 251.394 260.496 251.431 260.863 251.507C263.641 252.051 265.742 254.566 265.742 257.579Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 244.821V267.622H111.161V244.73C111.675 244.798 112.19 244.836 112.719 244.836H112.902C113.027 244.836 113.145 244.836 113.27 244.821Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M127.687 234.436C127.687 234.436 127.694 234.482 127.694 234.504C127.694 236.279 126.29 237.714 124.571 237.714C124.218 237.714 123.888 237.639 123.572 237.533C123.535 237.631 123.484 237.722 123.447 237.812C124.049 238.371 124.431 239.179 124.431 240.078C124.431 241.77 123.094 243.144 121.448 243.144C120.772 243.144 120.155 242.91 119.655 242.518C117.84 243.869 115.65 244.708 113.27 244.821C113.145 244.829 113.027 244.836 112.902 244.836H112.719C112.19 244.836 111.675 244.798 111.161 244.73C108.574 244.383 106.252 243.175 104.467 241.392C104.276 241.43 104.085 241.453 103.879 241.453C102.233 241.453 100.896 240.078 100.896 238.379C100.896 238.205 100.918 238.039 100.947 237.865C98.4855 237.571 96.5676 235.418 96.5676 232.805C96.5676 230.849 97.6478 229.15 99.2276 228.296C99.11 227.964 99.0366 227.609 99.0366 227.231C99.0366 225.54 100.367 224.165 102.02 224.165C102.659 224.165 103.247 224.376 103.739 224.731C104.011 224.407 104.298 224.097 104.606 223.802C104.54 223.553 104.496 223.296 104.496 223.032C104.496 221.34 105.834 219.966 107.487 219.966C108.332 219.966 109.089 220.328 109.632 220.91C110.617 220.638 111.653 220.479 112.719 220.479C115.695 220.479 118.406 221.612 120.486 223.478C121.125 223.221 121.823 223.077 122.55 223.077C125.695 223.077 128.245 225.698 128.245 228.931C128.245 230.298 127.782 231.544 127.025 232.541C127.422 233.069 127.679 233.719 127.687 234.436Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M148.364 245.569V267.607H116.532V245.184H146.608C147.181 245.357 147.761 245.486 148.364 245.569Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M153.272 245.184V267.607H148.364V245.569C148.878 245.637 149.4 245.675 149.929 245.675C150.113 245.675 150.296 245.667 150.48 245.659C151.443 245.614 152.369 245.448 153.25 245.184H153.272Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M146.607 245.184H113.269V244.821C115.65 244.708 117.84 243.87 119.655 242.518C120.155 242.91 120.772 243.145 121.448 243.145C123.094 243.145 124.431 241.77 124.431 240.078C124.431 239.18 124.049 238.371 123.446 237.813C123.483 237.722 123.535 237.631 123.571 237.533C123.887 237.639 124.218 237.714 124.571 237.714C126.29 237.714 127.694 236.279 127.694 234.505C127.694 234.482 127.694 234.459 127.686 234.437L134.902 229.361L135.505 229.784C134.446 230.713 133.778 232.095 133.778 233.644C133.778 236.257 135.688 238.402 138.157 238.704C138.128 238.87 138.106 239.036 138.106 239.217C138.106 240.909 139.443 242.284 141.089 242.284C141.273 242.284 141.457 242.261 141.633 242.231C141.648 242.231 141.662 242.223 141.677 242.223C143.044 243.583 144.726 244.617 146.607 245.184Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 244.821V245.184H112.403L112.902 244.836C113.027 244.836 113.145 244.836 113.27 244.821Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M184.736 113.287V250.032C184.104 250.032 183.59 250.561 183.59 251.211C183.59 251.248 183.59 251.286 183.59 251.324C180.813 251.868 178.711 254.383 178.711 257.396H180.181V265.462H179.255V267.622H150.472V267.607H153.265V245.184H153.243C154.146 244.912 154.999 244.527 155.792 244.058C156.16 243.847 156.513 243.605 156.858 243.356C157.358 243.741 157.975 243.983 158.643 243.983C160.297 243.983 161.634 242.608 161.634 240.909C161.634 240.01 161.245 239.21 160.642 238.643C160.686 238.553 160.738 238.462 160.774 238.364C161.09 238.477 161.421 238.545 161.766 238.545C163.493 238.545 164.889 237.11 164.889 235.335C164.889 234.595 164.64 233.923 164.221 233.379C164.985 232.382 165.44 231.129 165.44 229.762C165.44 226.529 162.891 223.908 159.746 223.908C159.018 223.908 158.328 224.059 157.688 224.309C155.609 222.451 152.897 221.31 149.921 221.31C148.849 221.31 147.82 221.476 146.835 221.748C146.291 221.167 145.535 220.797 144.682 220.797C143.036 220.797 141.699 222.171 141.699 223.863C141.699 224.135 141.743 224.384 141.809 224.633C141.75 224.694 141.684 224.754 141.625 224.822V113.287H184.729H184.736Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M122.116 262.464V249.799H145.05",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M122.116 262.464V249.799H145.05",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M153.273 245.184V267.607H150.481V267.622H141.634V267.607H148.365V245.569C148.879 245.637 149.401 245.675 149.93 245.675C150.114 245.675 150.297 245.667 150.481 245.659C151.444 245.614 152.37 245.448 153.251 245.184H153.273Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M171.173 84.7686V113.294",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M175.045 96.5732V113.294",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M165.809 126.844H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M159.519 136.428H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M161.136 146.843H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M159.997 159.554H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M159.791 169.138H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M163.825 180.564H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M170.1 190.881H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M161.628 203.592H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M171.136 213.916H141.634",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M180.189 257.396V265.462H189.286V257.396H180.189ZM184.738 261.587C184.106 261.587 183.591 261.066 183.591 260.409C183.591 259.752 184.106 259.231 184.738 259.231C185.37 259.231 185.891 259.759 185.891 260.409C185.891 261.058 185.377 261.587 184.738 261.587Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M190.212 265.462H179.263V267.622H190.212V265.462Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M185.891 260.41C185.891 261.067 185.377 261.588 184.738 261.588C184.098 261.588 183.591 261.067 183.591 260.41C183.591 259.753 184.106 259.231 184.738 259.231C185.37 259.231 185.891 259.76 185.891 260.41Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M185.884 251.21C185.884 251.248 185.884 251.286 185.877 251.324C185.509 251.248 185.127 251.21 184.738 251.21C184.348 251.21 183.966 251.248 183.599 251.324C183.599 251.286 183.599 251.248 183.599 251.21C183.599 250.561 184.113 250.032 184.745 250.032C185.377 250.032 185.891 250.561 185.891 251.21H185.884Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M190.756 257.395H178.72C178.72 254.382 180.821 251.867 183.599 251.323C183.966 251.248 184.348 251.21 184.738 251.21C185.127 251.21 185.509 251.248 185.877 251.323C188.654 251.867 190.756 254.382 190.756 257.395Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.481 245.66V267.623H148.365V245.569C148.879 245.637 149.401 245.675 149.93 245.675C150.113 245.675 150.297 245.668 150.481 245.66Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M164.229 233.379C164.648 233.923 164.898 234.595 164.898 235.335C164.898 237.11 163.502 238.545 161.775 238.545C161.43 238.545 161.099 238.477 160.783 238.364C160.746 238.462 160.695 238.553 160.651 238.643C161.253 239.21 161.643 240.01 161.643 240.909C161.643 242.608 160.305 243.983 158.652 243.983C157.983 243.983 157.366 243.741 156.866 243.356C156.521 243.605 156.168 243.847 155.801 244.059C155.007 244.527 154.155 244.912 153.251 245.184C152.369 245.448 151.444 245.614 150.481 245.66C150.297 245.667 150.114 245.675 149.93 245.675C149.401 245.675 148.879 245.637 148.365 245.569C147.762 245.486 147.182 245.358 146.609 245.184C144.728 244.617 143.045 243.583 141.678 242.223C141.663 242.223 141.649 242.231 141.634 242.231C141.458 242.261 141.274 242.284 141.09 242.284C139.444 242.284 138.107 240.909 138.107 239.217C138.107 239.036 138.129 238.87 138.158 238.704C135.689 238.402 133.779 236.257 133.779 233.644C133.779 232.095 134.448 230.713 135.506 229.784C135.785 229.528 136.101 229.309 136.439 229.127C136.321 228.795 136.241 228.44 136.241 228.07C136.241 226.371 137.578 225.004 139.231 225.004C139.87 225.004 140.458 225.215 140.943 225.562C141.164 225.306 141.392 225.056 141.634 224.822C141.693 224.754 141.759 224.694 141.818 224.634C141.752 224.384 141.707 224.135 141.707 223.863C141.707 222.171 143.045 220.797 144.691 220.797C145.543 220.797 146.3 221.167 146.844 221.748C147.828 221.477 148.857 221.31 149.93 221.31C152.906 221.31 155.617 222.451 157.697 224.309C158.336 224.06 159.027 223.908 159.754 223.908C162.899 223.908 165.449 226.529 165.449 229.762C165.449 231.129 164.993 232.382 164.229 233.379Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M530.169 229.943C530.059 230.079 529.963 230.222 529.868 230.366C529.14 229.664 528.163 229.233 527.09 229.233C524.864 229.233 523.049 231.091 523.049 233.387C523.049 233.689 523.086 233.991 523.144 234.278C520.536 234.769 518.486 236.914 518.082 239.625H483.928L498.925 229.075L513.923 218.531L528.927 229.075L530.169 229.943Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M538.421 256.204V267.623H489.432V239.626H518.082C518.023 239.951 518.001 240.291 518.001 240.63C518.001 244.203 520.815 247.095 524.291 247.095C524.409 247.095 524.526 247.088 524.636 247.08C524.982 247.662 525.415 248.19 525.93 248.644C527.127 249.731 528.744 250.434 530.537 250.554V267.374H532.653V250.411C533.02 250.351 533.373 250.252 533.711 250.131C533.601 250.494 533.542 250.887 533.542 251.287C533.542 253.47 535.262 255.237 537.385 255.237C537.451 255.237 537.525 255.229 537.598 255.229C537.819 255.599 538.098 255.932 538.421 256.204Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M493.863 253.976H522.903",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M495.839 260.478H523.556",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M498.375 247.473H514.46",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M532.653 250.41V267.373H530.537V250.554C530.721 250.561 530.904 250.569 531.088 250.569C531.22 250.569 531.352 250.569 531.485 250.561C531.882 250.539 532.278 250.493 532.653 250.41Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M545.189 240.509C545.189 241.649 544.946 242.729 544.52 243.703C543.433 246.15 541.14 247.903 538.421 248.167C538.186 248.19 537.944 248.205 537.701 248.205C537.378 248.205 537.069 248.174 536.753 248.137C535.96 249.02 534.909 249.715 533.711 250.131C533.373 250.251 533.021 250.35 532.653 250.41C532.278 250.493 531.882 250.538 531.485 250.561C531.352 250.569 531.22 250.569 531.088 250.569C530.904 250.569 530.721 250.561 530.537 250.553C528.744 250.433 527.127 249.73 525.93 248.643C525.415 248.19 524.982 247.661 524.636 247.079C524.526 247.087 524.409 247.094 524.291 247.094C520.815 247.094 518.001 244.202 518.001 240.63C518.001 240.29 518.023 239.95 518.082 239.625C518.486 236.914 520.536 234.769 523.145 234.278C523.086 233.991 523.049 233.689 523.049 233.387C523.049 231.091 524.864 229.233 527.091 229.233C528.163 229.233 529.141 229.663 529.868 230.366C529.964 230.222 530.059 230.079 530.169 229.943C531.125 228.704 532.602 227.911 534.255 227.911C537.069 227.911 539.355 230.184 539.479 233.047C542.757 233.87 545.189 236.891 545.189 240.509Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M542.492 257.26V267.622H541.199V257.35C541.309 257.35 541.419 257.358 541.537 257.358C541.867 257.358 542.183 257.328 542.492 257.26Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M550.148 251.218C550.148 253.808 548.098 255.916 545.578 255.916C545.379 255.916 545.188 255.9 544.997 255.87C544.373 256.565 543.498 257.063 542.492 257.26C542.183 257.328 541.867 257.358 541.536 257.358C541.419 257.358 541.309 257.35 541.198 257.35C540.118 257.275 539.148 256.86 538.421 256.203C538.098 255.931 537.818 255.598 537.598 255.228C537.524 255.228 537.451 255.236 537.385 255.236C535.261 255.236 533.542 253.468 533.542 251.286C533.542 250.886 533.601 250.493 533.711 250.13C534.909 249.715 535.959 249.02 536.753 248.136C537.069 248.174 537.377 248.204 537.701 248.204C537.943 248.204 538.186 248.189 538.421 248.167C541.14 247.902 543.432 246.15 544.52 243.703C545.725 244.126 546.599 245.282 546.665 246.656C548.664 247.155 550.148 249.005 550.148 251.218Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M233.955 250.266V267.621H231.839V250.402C232.022 250.409 232.206 250.417 232.39 250.417C232.926 250.417 233.455 250.364 233.955 250.266Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M246.491 240.365C246.491 241.505 246.248 242.585 245.822 243.56C244.639 246.218 242.03 248.061 239.003 248.061C238.687 248.061 238.371 248.031 238.062 247.993C237.261 248.869 236.218 249.564 235.02 249.979C234.682 250.1 234.322 250.198 233.955 250.266C233.455 250.364 232.926 250.417 232.39 250.417C232.206 250.417 232.022 250.417 231.839 250.402C229.281 250.228 227.092 248.869 225.945 246.936C225.828 246.943 225.71 246.951 225.593 246.951C222.117 246.951 219.303 244.058 219.303 240.486C219.303 237.314 221.522 234.685 224.454 234.127C224.388 233.84 224.351 233.545 224.351 233.235C224.351 230.947 226.166 229.081 228.392 229.081C229.473 229.081 230.442 229.519 231.17 230.222C232.103 228.742 233.72 227.76 235.557 227.76C238.371 227.76 240.656 230.041 240.781 232.895C244.058 233.719 246.491 236.747 246.491 240.365Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M243.794 257.116V267.629H242.501V257.207C242.611 257.207 242.721 257.207 242.839 257.207C243.169 257.207 243.485 257.176 243.794 257.108V257.116Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M251.45 251.067C251.45 253.665 249.407 255.772 246.88 255.772C246.681 255.772 246.49 255.75 246.299 255.727C245.675 256.422 244.8 256.92 243.793 257.117C243.485 257.185 243.169 257.215 242.838 257.215C242.721 257.215 242.61 257.215 242.5 257.215C240.935 257.101 239.598 256.271 238.9 255.092C238.826 255.092 238.76 255.1 238.687 255.1C236.563 255.1 234.844 253.333 234.844 251.15C234.844 250.742 234.902 250.357 235.02 249.987C236.218 249.572 237.261 248.877 238.062 248.001C238.371 248.038 238.687 248.069 239.003 248.069C242.03 248.069 244.638 246.226 245.821 243.567C247.027 243.99 247.901 245.138 247.967 246.513C249.966 247.019 251.45 248.869 251.45 251.075V251.067Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M363.647 250.668V267.623H361.531V250.804C361.715 250.811 361.899 250.819 362.082 250.819C362.619 250.819 363.148 250.766 363.647 250.668Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M373.486 257.518V267.562H372.193V257.608C372.303 257.608 372.414 257.616 372.531 257.616C372.862 257.616 373.178 257.586 373.486 257.518Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M381.143 251.468C381.143 253.326 380.1 254.927 378.586 255.69C377.976 256 377.293 256.174 376.573 256.174C376.375 256.174 376.184 256.159 375.992 256.128C375.368 256.823 374.493 257.322 373.487 257.518C373.178 257.586 372.862 257.616 372.532 257.616C372.414 257.616 372.304 257.609 372.194 257.609C371.62 257.571 371.069 257.427 370.577 257.201C369.725 256.831 369.034 256.227 368.593 255.486C368.519 255.486 368.453 255.494 368.38 255.494C366.256 255.494 364.537 253.727 364.537 251.544C364.537 251.136 364.596 250.751 364.713 250.381C365.125 248.991 366.264 247.934 367.682 247.662C367.645 247.488 367.623 247.307 367.623 247.118C367.623 245.713 368.725 244.581 370.092 244.581C370.261 244.581 370.423 244.596 370.577 244.626C371.04 244.724 371.451 244.951 371.782 245.275C372.355 244.369 373.34 243.772 374.464 243.772C374.714 243.772 374.956 243.803 375.192 243.863C375.302 243.886 375.412 243.924 375.515 243.961C376.72 244.384 377.594 245.54 377.66 246.907C379.659 247.413 381.143 249.263 381.143 251.468Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M381.32 199.175V212.981L380.071 214.234L372.414 221.923V199.175H381.32Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M419.559 235.585L414.004 239.497H419.559V267.51H370.577V257.2C371.069 257.427 371.62 257.57 372.194 257.608C372.304 257.608 372.414 257.616 372.532 257.616C372.862 257.616 373.178 257.586 373.487 257.518C374.494 257.321 375.368 256.823 375.993 256.128C376.184 256.158 376.375 256.173 376.573 256.173C377.293 256.173 377.977 256 378.586 255.69C380.1 254.927 381.144 253.326 381.144 251.468C381.144 249.263 379.659 247.412 377.661 246.906C377.594 245.539 376.72 244.384 375.515 243.961C375.941 242.987 376.184 241.907 376.184 240.766C376.184 239.377 375.824 238.077 375.192 236.952C374.207 235.177 372.546 233.856 370.577 233.335V229.294H419.559V235.585Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M421.344 225.556V229.294H368.46C367.792 228.758 366.991 228.388 366.116 228.244L372.414 221.923L380.07 214.234L381.32 212.981L395.068 199.175L410.065 214.234L421.344 225.556Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M412.49 235.117H408.882V255.69H412.49V235.117Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M376.183 240.766C376.183 241.907 375.941 242.987 375.515 243.961C375.412 243.923 375.301 243.885 375.191 243.863C374.956 243.802 374.714 243.772 374.464 243.772C373.339 243.772 372.355 244.369 371.782 245.275C371.451 244.95 371.04 244.724 370.577 244.626C370.422 244.595 370.261 244.58 370.092 244.58C368.725 244.58 367.623 245.713 367.623 247.118C367.623 247.307 367.645 247.488 367.681 247.662C366.263 247.934 365.124 248.991 364.713 250.381C364.375 250.501 364.015 250.6 363.647 250.668C363.148 250.766 362.619 250.819 362.082 250.819C361.899 250.819 361.715 250.811 361.531 250.803C358.974 250.63 356.777 249.27 355.631 247.337C355.52 247.344 355.403 247.352 355.285 247.352C351.81 247.352 348.995 244.459 348.995 240.887C348.995 237.715 351.215 235.087 354.139 234.535C354.08 234.241 354.044 233.946 354.044 233.637C354.044 231.348 355.858 229.483 358.085 229.483C359.165 229.483 360.135 229.921 360.863 230.623C361.796 229.143 363.412 228.161 365.249 228.161C365.543 228.161 365.837 228.184 366.116 228.244C366.991 228.388 367.792 228.758 368.46 229.294H370.577V233.335C372.546 233.856 374.207 235.177 375.191 236.952C375.823 238.078 376.183 239.377 376.183 240.766Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M402.909 235.117V255.69H378.586C380.1 254.927 381.144 253.326 381.144 251.468C381.144 249.263 379.659 247.413 377.661 246.907C377.595 245.54 376.72 244.384 375.515 243.961C375.941 242.987 376.184 241.907 376.184 240.766C376.184 239.377 375.824 238.078 375.192 236.952V235.117H402.909Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M430.251 218.396V228.071L429.002 228.947L421.345 234.332V218.396H430.251Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M474.001 239.498H414.004L419.559 235.586L421.344 234.332L429.001 228.947L430.25 228.071L443.999 218.396L459.003 228.947L474.001 239.498Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M466.249 247.292C466.249 248.984 467.153 250.472 468.497 251.242V267.488H419.508V239.498H468.497V243.335C467.153 244.113 466.249 245.593 466.249 247.292Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M461.421 243.576H457.813V257.986H461.421V243.576Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M451.839 243.576H424.122V257.986H451.839V243.576Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M470.672 251.279V267.487",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M475.095 247.292C475.095 249.799 473.119 251.838 470.672 251.838C469.878 251.838 469.143 251.627 468.497 251.242C467.152 250.471 466.248 248.983 466.248 247.292C466.248 245.6 467.152 244.112 468.497 243.334C469.143 242.957 469.878 242.745 470.672 242.745C473.119 242.745 475.095 244.777 475.095 247.292Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M195.172 251.415V267.623",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M195.172 251.974C197.615 251.974 199.595 249.938 199.595 247.427C199.595 244.916 197.615 242.881 195.172 242.881C192.729 242.881 190.748 244.916 190.748 247.427C190.748 249.938 192.729 251.974 195.172 251.974Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M321.081 194.152H305.334V210.209H321.081V194.152Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M372.517 220.722H299.962V267.623H372.517V220.722Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M375.699 210.209H296.781V220.722H375.699V210.209Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M362.965 231.008H337.71V267.373H362.965V231.008Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M316.268 231.008H306.76V240.169H316.268V231.008Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M330.581 231.008H321.073V240.169H330.581V231.008Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M375.699 215.466H330.582",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 267.622H629",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M502.805 158.95C502.629 158.95 502.445 158.958 502.269 158.981C501.321 154.615 497.537 151.353 493.003 151.353C487.757 151.353 483.502 155.725 483.502 161.118C483.502 162.054 483.634 162.953 483.877 163.807C482.216 164.456 481.033 166.103 481.033 168.044C481.033 170.551 483.01 172.583 485.449 172.583C486.772 172.583 487.955 171.978 488.763 171.034C489.623 173.474 491.886 175.218 494.561 175.218C497.603 175.218 500.131 172.945 500.63 169.962C501.299 170.256 502.034 170.415 502.805 170.415C505.884 170.415 508.383 167.847 508.383 164.683C508.383 161.518 505.884 158.95 502.805 158.95Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M477.697 161.11C476.337 161.11 475.235 162.243 475.235 163.64C475.235 165.038 476.337 166.171 477.697 166.171C479.056 166.171 480.158 165.038 480.158 163.64C480.158 162.243 479.056 161.11 477.697 161.11Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M217.017 111.8C217.017 111.098 216.466 110.531 215.783 110.531C215.1 110.531 214.549 111.098 214.549 111.8C214.549 112.502 215.1 113.069 215.783 113.069C216.466 113.069 217.017 112.502 217.017 111.8Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M228.465 121.943C228.407 121.943 228.348 121.958 228.289 121.958C228.304 121.8 228.311 121.641 228.311 121.475C228.311 118.771 226.18 116.573 223.542 116.573C220.904 116.573 218.773 118.763 218.773 121.475C218.773 121.649 218.781 121.822 218.803 121.988C217.098 122.238 215.775 123.725 215.775 125.546C215.775 127.539 217.348 129.156 219.288 129.156C220.177 129.156 220.985 128.808 221.602 128.249C222.205 129.367 223.351 130.13 224.681 130.13C226.526 130.13 228.025 128.672 228.186 126.814C228.274 126.822 228.37 126.837 228.465 126.837C229.781 126.837 230.854 125.742 230.854 124.383C230.854 123.023 229.788 121.928 228.465 121.928V121.943Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M121.258 159.553C120.501 159.553 119.773 159.682 119.09 159.908C117.657 157.733 115.24 156.306 112.499 156.306C108.766 156.306 105.65 158.949 104.783 162.506C103.505 162.597 102.344 163.095 101.411 163.881C99.8307 161.283 97.0385 159.553 93.8421 159.553C88.9115 159.553 84.9142 163.662 84.9142 168.73C84.9142 173.797 88.9115 177.906 93.8421 177.906C94.5695 177.906 95.2676 177.808 95.9436 177.641C96.7886 181.093 99.816 183.646 103.431 183.646C105.276 183.646 106.973 182.981 108.303 181.871C110.059 184.016 112.697 185.383 115.636 185.383C120.934 185.383 125.226 180.972 125.226 175.527C125.226 174.605 125.093 173.722 124.866 172.876C126.886 171.615 128.246 169.341 128.246 166.736C128.246 162.771 125.115 159.553 121.258 159.553Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M128.794 154.905C130.321 153.335 130.321 150.791 128.794 149.222C127.268 147.653 124.793 147.653 123.266 149.222C121.739 150.791 121.739 153.335 123.266 154.905C124.793 156.474 127.268 156.474 128.794 154.905Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6638 186.568C83.8342 186.568 82.3499 188.094 82.3499 189.975C82.3499 191.855 83.8342 193.381 85.6638 193.381C87.4935 193.381 88.9778 191.855 88.9778 189.975C88.9778 188.094 87.4935 186.568 85.6638 186.568Z",
    fill: "white",
    stroke: "#16304F",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3855_5944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 629,
    height: 268,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.ae10777afee61e4fc952d2c3033192cd.svg";
export { ForwardRef as ReactComponent };